export function register(state: object = {registering: false, error: ''}, action: any) {
    switch (action.type) {
        case 'REGISTER_ERROR':
            return Object.assign({}, state, {error: action.data})

        case 'REGISTERING':
            return Object.assign({}, state, {isSubmitting: action.data})

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Auth/Register/reducers.tsx